import { PrivateCatalogService } from '../../../catalog-services/private-catalog-service';
export class PrivateSettings extends PrivateCatalogService {
    getSettings(requestConfig) {
        return this.get('/catalog/settings', requestConfig);
    }
    /**
     * Either create new or update existing settings
     * @param {Settings} settings
     * @param {RequestOptions} requestConfig
     * @returns {Promise<HttpResponse<Settings>>}
     * @example
     *
     * const updatedSettings = await new PrivateSettings()
     *  .update({settingName: true})
     *  .then(response => response.data);
     */
    update(settings, requestConfig) {
        return this.post('/catalog/settings', settings, {
            ...requestConfig,
        });
    }
    /**
     * Reset settings
     * @param {RequestOptions} requestConfig
     * @returns {Promise<HttpResponse>}
     * @example
     *
     * const service = new PrivateSettings();
     * await service.reset();
     *
     * const settings = await service
     *  .get()
     *  .then(response => response.data);
     *
     * Object.keys(settings).length === 0 // true
     */
    reset(requestConfig) {
        return this.delete('/catalog/settings', requestConfig);
    }
}
//# sourceMappingURL=settings.js.map